import React, { Component } from 'react'
import classNames from 'classnames'
import styles from './styles.css'
import Star from './star.svg'
import { NumericPathFlowQuestionProps } from '../'

interface State {
  rating?: number
}

class StarRatingQuestion extends Component<NumericPathFlowQuestionProps, State> {
  constructor(props: NumericPathFlowQuestionProps) {
    super(props)

    this.state = {}

    if (props.value !== null) {
      this.state = {
        rating: props.value
      }

      props.onFieldValidityChanged(true)
    }

    this.handleUpdateRating = this.handleUpdateRating.bind(this)
  }

  public handleUpdateRating(rating: number) {
    this.setState(
      {
        rating
      },
      () => {
        this.props.onFieldValueChanged({
          value: rating
        })
        this.props.onFieldValidityChanged(true)
      }
    )
  }

  public handleIsStarSelected(rating: number) {
    if (!this.state.rating || this.state.rating === 0 || rating > this.state.rating) {
      return false
    }

    return true
  }

  public render() {
    const { question } = this.props
    const ratings = [1, 2, 3, 4, 5]

    return (
      <>
        <div className={styles.starWrapper} key={question.internalName}>
          {ratings.map(rating => (
            <button
              type="button"
              className={styles.starButton}
              key={rating}
              onClick={() => this.handleUpdateRating(rating)}
            >
              <Star
                className={classNames({
                  [styles.selected]: this.handleIsStarSelected(rating)
                })}
              />
            </button>
          ))}
        </div>

        <div className={styles.dialog}>
          <div className={styles.desktopCopy}>
            <div>
              <strong>Your feedback matters!</strong>
            </div>
            <div>Every review allows our experts to help you better</div>
            <div>
              <strong>Thanks you for shopping with us!</strong>
            </div>
          </div>
          <div className={styles.mobileCopy}>
            <div>Every review allows our experts to help you better</div>
            <div>
              <strong>Thank you for shopping with us</strong>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default StarRatingQuestion
